export const PAYPAL_HOSTED_URL =
  process.env.REACT_APP_PAYPAL_URL ||
  "https://www.paypal.com/ncp/payment/A4JUXCC79NHAC";

import api from "./api";

/**
 * Records purchase intent (fire-and-forget) then redirects the current tab to
 * the PayPal hosted payment page. NEVER opens a new tab. NEVER uses PayPal SDK.
 */
export async function goToPayPal({ plan_id, plan_name, price, email }) {
  try {
    await api.post("/purchase-intent", { plan_id, plan_name, price, email: email || null });
  } catch {
    // ignore analytics failure — still redirect
  }
  window.location.href = PAYPAL_HOSTED_URL;
}
